import React, { useEffect } from "react";
import { X } from "lucide-react";

// Common frame for every Departments modal: fixed header (title never runs
// under the close button), scrollable body, footer for actions.
const ModalShell = ({ styles, t, title, subtitle, onClose, busy = false, maxWidth, footer, children }) => {
  const close = () => { if (!busy) onClose(); };

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape" && !busy) onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [busy, onClose]);

  return (
    <div className="dept-modal-overlay" style={styles.overlay} onClick={close}>
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        style={styles.modal(maxWidth)}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={styles.modalHeader}>
          <div style={{ minWidth: 0 }}>
            <h2 style={styles.modalTitle}>{title}</h2>
            {subtitle && <p style={styles.modalSubtitle}>{subtitle}</p>}
          </div>
          <button
            type="button"
            className="dept-icon-btn"
            style={styles.iconBtn()}
            onClick={close}
            disabled={busy}
            aria-label={t.close}
            title={t.close}
          >
            <X size={18} />
          </button>
        </div>
        <div style={styles.modalBody}>{children}</div>
        {footer && <div style={styles.modalFooter}>{footer}</div>}
      </div>
    </div>
  );
};

export default ModalShell;
